/**
 * USDA ERS Frontier and Remote Area (FAR) Codes — ZIP-level lookup.
 * Generated by data_raw/build_far.R from the ERS FAR 2020 ZIP-code file.
 *
 * Value: integer 0–4 giving the highest FAR level a ZIP qualifies for.
 *   0 = not frontier/remote at any level
 *   1 = FAR Level 1 (least remote)  …  4 = FAR Level 4 (most remote)
 * FAR classifies remoteness by travel time to urban areas of four size
 * classes; the levels are nested, so we store the highest level flagged.
 *
 * Geography note: FAR uses USPS ZIP areas; the app's geocoded `postcode`
 * is a ZCTA. The two are ~99% aligned (both 5-digit) but not identical —
 * the same simplification the RUCA lookup already makes.
 *
 * Source: https://www.ers.usda.gov/data-products/frontier-and-remote-area-codes
 */

let _data = null;
let _loadPromise = null;

export function loadFarData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/far.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load FAR data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getFARForZip(zip) {
  if (!_data || zip == null) return null;
  const key = String(zip).padStart(5, "0");
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const FAR_LABELS = {
  0: "Not frontier/remote",
  1: "FAR Level 1",
  2: "FAR Level 2",
  3: "FAR Level 3",
  4: "FAR Level 4",
};

export function getFARDescription(level) {
  if (level == null) return null;
  return FAR_LABELS[level] ?? null;
}

const far = { loadFarData, getFARForZip, getFARDescription };
export default far;
